import styled, { keyframes } from 'styled-components'
import { Box } from 'src/components'

const waveAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  70% {
    transform: translateX(-90%);
  }
  0% {
    transform: translateX(0);
  }
`
export const WaveContainer = styled(Box)`
    position: absolute !important;
    bottom: -5px !important;
    width: 100% !important;
    z-index: 1 !important;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        bottom: 0 !important;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`

export const Waves = styled.svg`
    width: 100%;
    height: 80px;
    overflow: hidden;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        height: 120px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        height: 100px;
    }
`

export const MovingWaves = styled.g`
    animation: ${waveAnimation} 20s linear infinite;
    transform: translateX(0);
    animation-delay: -2s;
`
